<template>
  <span>
    <v-btn @click="dialog = !dialog" color="green" dark>Tạo phiếu chi</v-btn>
    <v-dialog max-width="80%" v-model="dialog">
      <app-card>
        <h4>TẠO PHIẾU CHI</h4>
        <p class="fs-14 grey--text">Tạo phiếu chi mới</p>
        <v-form ref="form">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <v-select :items="EXPENSE_ACCOUNT_OPTIONS" :disabled="loading.submit" v-model="form.type"
                  :rules="[rules.required]" prepend-icon="list" label="Loại chi"></v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-select label="Tòa nhà"
                  :disabled="loading.submit || ![ACCOUNT_TYPES.RETURN_DEPOSIT, ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED, ACCOUNT_TYPES.WATER, ACCOUNT_TYPES.ELECTRICITY].includes(form.type)"
                  v-model="form.building" :items="list_building" prepend-icon="domain" :rules="[ACCOUNT_TYPES.RETURN_DEPOSIT, ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED].includes(form.type) ? [rules.required] : []
                    " @change="form.room_id = ''" required></v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-autocomplete label="Số phòng"
                  :disabled="loading.submit || ![ACCOUNT_TYPES.RETURN_DEPOSIT, ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED].includes(form.type)"
                  v-model="form.room_id" :items="room_ids" item-text="room_id" item-value="rooms_id"
                  prepend-icon="meeting_room" :rules="[ACCOUNT_TYPES.RETURN_DEPOSIT, ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED].includes(form.type) ? [rules.required] : []
                    " required
                  @change="form.type === ACCOUNT_TYPES.RETURN_DEPOSIT ? findReceiptReturnDeposit() : findCancelledDeposit()"></v-autocomplete>
              </v-flex>
              <v-flex xs12 md3>
                <wallet label="Hình thức chi" :input.sync="form.wallet_account_id" :disabled="loading.submit" required
                  :isCashOnly="true"></wallet>
              </v-flex>
              <v-flex xs12 md3 v-if="form.type === ACCOUNT_TYPES.MONTHLY_REPAIR_AND_MATERIAL_PURCHASE">
                <v-select :items="repairmen_name" :disabled="loading.submit"
                  v-model="form.repairman_name" :rules="[rules.required]" prepend-icon="person_pin" label="Thợ sửa"
                  @change="getRepairTimesheetsTotalPaymentInMonth"></v-select>
              </v-flex>
              <v-flex xs12 md3 v-if="form.type === ACCOUNT_TYPES.MANAGEMENT_STAFF_SALARY">
                <v-select label="Đối tượng chi lương" :disabled="loading.submit" v-model="form.salary_recipient"
                  :items="SALARY_RECIPIENT_OPTIONS" item-text="text" item-value="value" prepend-icon="person"
                  :rules="[rules.required]" required></v-select>
              </v-flex>
              <v-flex xs12 md3 v-if="form.type === ACCOUNT_TYPES.LAND_RENT">
                <v-select label="Vị trí thuê đất" :disabled="loading.submit" v-model="form.land_rent_location"
                  :items="LAND_RENT_LOCATION_OPTIONS" item-text="text" item-value="value" prepend-icon="location_on"
                  :rules="[rules.required]" required></v-select>
              </v-flex>
              <v-flex xs12 md3 v-if="form.type === ACCOUNT_TYPES.MATERIAL_PURCHASE">
                <v-select label="Loại chi mua vật tư" :disabled="loading.submit" v-model="form.material_purchase_type"
                  :items="MATERIAL_PURCHASE_TYPE_OPTIONS" item-text="text" item-value="value" prepend-icon="build"
                  :rules="[rules.required]" required></v-select>
              </v-flex>
              <v-flex xs12 md3 v-if="form.type === ACCOUNT_TYPES.REPAIR">
                <v-select label="Loại chi sửa chữa" :disabled="loading.submit" v-model="form.repair_expense_type"
                  :items="REPAIR_EXPENSE_TYPE_OPTIONS" item-text="text" item-value="value" prepend-icon="handyman"
                  :rules="[rules.required]" required></v-select>
              </v-flex>

              <v-flex xs12 md3 v-if="form.type === ACCOUNT_TYPES.LOAN_INTEREST">
                <v-select label="Đối tượng chi lãi vay" :disabled="loading.submit" v-model="form.loan_interest_object"
                  :items="LOAN_OBJECT_OPTIONS" item-text="text" item-value="value" prepend-icon="account_balance"
                  :rules="[rules.required]" required></v-select>
              </v-flex>
              <template> </template>
              <v-flex xs12 md3 v-if="form.type !== ACCOUNT_TYPES.MONTHLY_REPAIR_AND_MATERIAL_PURCHASE">
                <v-select label="Người nhận" :disabled="loading.submit" v-model="form.receiver"
                  :items="[...bvs, { name: 'Khác' }]" item-text="name" item-value="name" prepend-icon="person_pin"
                  required></v-select>
              </v-flex>
              <v-flex xs12 md3 v-if="form.type === ACCOUNT_TYPES.MONTHLY_REPAIR_AND_MATERIAL_PURCHASE">
                <v-menu :close-on-content-click="false" v-model="menu_analysis_date" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width min-width="290px">
                  <v-text-field slot="activator" v-model="form.analysis_date" label="Thời gian"
                    :disabled="loading.submit" prepend-icon="event" readonly></v-text-field>
                  <v-date-picker locale="vi-VI" v-model="form.analysis_date" type="month"
                    @input="getRepairTimesheetsTotalPaymentInMonth"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field label="Số tiền chi" :disabled="loading.submit" v-model="form.amount" prepend-icon="money"
                  :rules="[rules.required]" v-currency></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-menu :close-on-content-click="false" v-model="menu_date_created" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width min-width="290px">
                  <v-text-field slot="activator" v-model="form.date_created" label="Ngày tạo phiếu"
                    :disabled="loading.submit" prepend-icon="event" readonly :rules="[rules.required]"></v-text-field>
                  <v-date-picker locale="vi-VI" v-model="form.date_created"
                    @input="menu_date_created = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Ghi chú" v-model="form.note" prepend-icon="event_note"
                  :disabled="loading.submit"></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="alert.show">
                <v-alert :value="alert.show" :type="alert.type" outline>
                  {{ alert.text }}
                </v-alert>
              </v-flex>
              <v-flex xs12 v-if="
                form.type === 'return_deposit' && list_return_deposits.length
              ">
                <v-radio-group v-model="chosen_return_deposit" row>
                  <v-radio v-for="return_deposit in list_return_deposits" :key="return_deposit.check_out_id" :label="`Phiếu trả phòng: ${return_deposit.check_out_id
                    } - Số tiền trả cọc: ${return_deposit.amount.toLocaleString(
                      'vi-VI'
                    )} đ`
                    " :value="return_deposit" color="primary"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 v-if="
                form.type === ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED && list_cancelled_deposits.length
              ">
                <v-radio-group v-model="chosen_cancelled_deposit" row>
                  <v-radio v-for="cancelled_deposit in list_cancelled_deposits" :key="cancelled_deposit.receipt_id"
                    :label="`Phiếu cọc: ${cancelled_deposit.receipt_id
                      } - Số tiền cọc: ${cancelled_deposit.deposit_amount.toLocaleString(
                        'vi-VI'
                      )} đ`
                      " :value="cancelled_deposit" color="primary"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loading.submit" :disabled="loading.submit || alert.show" @click="submit" color="green"
              class="white--text">
              Tạo Phiếu
            </v-btn>
          </v-card-actions>
        </v-form>
      </app-card>
    </v-dialog>
  </span>
</template>

<script>
import api from "Api";
import moment from "moment";
import { Wallet } from "Components/Form";
import {
  BANK_ACCOUNT_TYPE_LIST,
  list_building,
  EXPENSE_ACCOUNT_OPTIONS,
  ACCOUNT_TYPES,
  SALARY_RECIPIENT_OPTIONS,
  LAND_RENT_LOCATION_OPTIONS,
  MATERIAL_PURCHASE_TYPE_OPTIONS,
  REPAIR_EXPENSE_TYPE_OPTIONS,
  LOAN_OBJECT_OPTIONS,
} from "Constants/db-config";
import { buildParamQuery,parseCurrency  } from "Helpers";

export default {
  name: "dialog-tao-phieu-chi",
  components: {
    Wallet,
  },
  data() {
    return {
      dialog: false,
      menu_date_created: false,
      menu_analysis_date: false,
      loading: {
        submit: false,
      },
      form: {
        date_created: "",
        amount: "",
        type: "",
        wallet_account_id: null,
        note: "",
        receiver: "",
        building: "",
        room_id: "",
        check_out_id: "",
        analysis_date: "",
        repairman_name: "",
        salary_recipient: "",
        land_rent_location: "",
        material_purchase_type: "",
        repair_expense_type: "",
        loan_interest_object: ""
      },
      list_building,
      rules: {
        required: (value) => !!value || "Vui lòng điền thông tin này.",
      },
      EXPENSE_ACCOUNT_OPTIONS,
      BANK_ACCOUNT_TYPE_LIST,
      ACCOUNT_TYPES,
      SALARY_RECIPIENT_OPTIONS,
      LAND_RENT_LOCATION_OPTIONS,
      MATERIAL_PURCHASE_TYPE_OPTIONS,
      REPAIR_EXPENSE_TYPE_OPTIONS,
      LOAN_OBJECT_OPTIONS,
      list_return_deposits: [],
      list_cancelled_deposits: [],
      chosen_return_deposit: "",
      chosen_cancelled_deposit: "",
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      repairmen_name: [],
    };
  },
  computed: {
    rooms() {
      return this.$store.state.app.rooms;
    },
    room_ids() {
      return this.rooms.filter((room) => room.building === this.form.building);
    },
    bvs() {
      return this.$store.state.app.bvs;
    },
  },
  mounted(){
    this.getRepairmenName();
  },
  watch: {
    "form.wallet_account_id": function (nv, ov) {
      if (!nv) return;

      const wallet_account = this.$store.state.app.wallets.find(
        (wallet) => wallet.id === nv
      );
    },
    "form.type"(nv) {
      if (nv !== "return_deposit") {
        this.form.room_id = "";
        this.form.building = "";
        this.chosen_return_deposit = "";
      }
      if (nv !== this.ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED) {
        this.form.room_id = "";
        this.form.building = "";
        this.chosen_cancelled_deposit = "";
      }
      this.alert.show = false;
    },
    "form.room_id"(nv) {
      this.chosen_return_deposit = "";
      this.chosen_cancelled_deposit = "";
    },
    chosen_return_deposit(nv) {
      if (nv) {
        this.form.amount = nv.amount.toLocaleString("vi-VI") + " ₫";
        this.form.check_out_id = nv.check_out_id;
        this.form.return_deposit_amount = nv.amount;
      } else {
        this.form.check_out_id = "";
        this.form.amount = "";
      }
    },
    chosen_cancelled_deposit(nv) {
      if (nv) {
        this.form.amount = nv.deposit_amount.toLocaleString("vi-VI") + " ₫";
        this.form.deposit_receipt_id = nv.receipt_id;
      } else {
        this.form.amount = "";
      }
    },
  },
  methods: {
    clearInput: function () {
      this.$refs.form.reset();
      this.form.wallet_account_id = null;
      this.list_return_deposits = [];
      this.list_cancelled_deposits = [];
    },
    findReceiptReturnDeposit: async function () {
      this.alert.show = false;
      // const params = {
      // 	building: this.chosen_building,
      // 	[this.search_type]: this.search,
      // 	lastDateOfMonth: last_date_of_month.toISOString(),
      // 	roomId: room_id,
      // 	isRefresh: true
      // }
      // const query = buildParamQuery(params)
      const params = {
        roomId: this.form.room_id,
        disbursementId: false,
      };
      const query = buildParamQuery(params);
      const data = await api.getListReturnDeposit(query);

      if (data.status == 200) {
        this.list_return_deposits = data.data.slice(0);
        if (!this.list_return_deposits.length) {
          this.alert.show = true;
          this.alert.text = `Không tìm thấy phiếu trả phòng của phòng ${this.form.room_id
            }`;
        } else {
          this.chosen_return_deposit = this.list_return_deposits[0];
        }
      } else {
        this.alert.show = true;
        this.alert.text = "Lỗi không tìm thấy dữ liệu";
      }
    },
    findCancelledDeposit: async function () {
      this.alert.show = false;
      const params = {
        roomId: this.form.room_id,
        isDisbursedForCancel: false,
      };
      const query = buildParamQuery(params);
      const data = await api.getListCancelledDeposit(query);

      if (data.status == 200) {
        this.list_cancelled_deposits = data.data.slice(0);
        if (!this.list_cancelled_deposits.length) {
          this.alert.show = true;
          this.alert.text = `Không tìm thấy phiếu cọc đã hủy của phòng ${this.form.room_id
            }`;
        } else {
          this.chosen_cancelled_deposit = this.list_cancelled_deposits[0];
        }
      } else {
        this.alert.show = true;
        this.alert.text = "Lỗi không tìm thấy dữ liệu";
      }
    },
    getRepairTimesheetsTotalPaymentInMonth: async function () {
      this.menu_analysis_date = false;

      if (this.form.type !== this.ACCOUNT_TYPES.MONTHLY_REPAIR_AND_MATERIAL_PURCHASE || !this.form.analysis_date || !this.form.repairman_name) {
        return;
      }

      this.alert.show = false;
      const params = {
        repairman_name: this.form.repairman_name,
        dateStart: moment(this.form.analysis_date).format("YYYY-MM-01"),
        dateEnd: moment(this.form.analysis_date)
          .endOf("month")
          .format("YYYY-MM-DD"),
      };
      const query = buildParamQuery(params);
      const data = await api.getRepairTimesheetsTotalPaymentInMonth(query);

      if (data.status == 200) {
        const { totalPayment } = data.data;

        this.form.amount = totalPayment

      } else {
        this.alert.show = true;
        this.alert.text = "Lỗi không tìm thấy dữ liệu";
      }
    },
    submit: async function () {
      if (!this.$refs.form.validate()) {
        swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin", "error");
        return;
      }
      this.loading.submit = true;
      const postData = {
        ...this.form,
        amount: parseCurrency(this.form.amount, "vi-VN", "VND"),
        receiver: this.form.receiver !== "Khác" ? this.form.receiver : "",
      };

      const data = await api.createDisbursementReceipt(postData);
      if (data.status === 200) {
        this.dialog = false;
        swal.fire("Thành công", data.data.message, "success");
        this.$emit("reloadTable");
        this.clearInput();
      } else {
        swal.fire("Lỗi", data.message, "error");
      }
      this.loading.submit = false;
    },
    async getRepairmenName() {
      const params = { };
      const query = buildParamQuery(params)
      const response = await api.getRepairmen(query);
      if (response.status === 200) {
        this.repairmen_name = response.data.map(item => {
          return item.name;
        });
      }
    }
  },
};
</script>

<style></style>
